import { render, staticRenderFns } from "./SbWorkAuthSupportingDocuments.vue?vue&type=template&id=6a82368e&"
import script from "./SbWorkAuthSupportingDocuments.vue?vue&type=script&lang=js&"
export * from "./SbWorkAuthSupportingDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VSpacer})
